// import React, { Component, useState, useRef, useEffect, useContext } from 'react';

// Import the functions you need from the SDKs you use
import { initializeApp, browserSessionPersistence } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// Use environment variables that will be injected by webpack DefinePlugin
// console.log('Firebase Configuration Loaded:');
// console.log('API Key:', process.env.REACT_APP_FIREBASE_CONFIG_API_KEY ? 'LOADED' : 'MISSING');



// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_CONFIG_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_CONFIG_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_CONFIG_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_CONFIG_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_CONFIG_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_CONFIG_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_CONFIG_MEASUREMENT_ID
}


// Initialize Firebase
// const app = initializeApp(firebaseConfig, { persistence: browserSessionPersistence });
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app);
// auth.languageCode = 'it';
// auth.languageCode = curLang;
const db = getFirestore(app);
// Export the initialized services

// window.recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {});

export { auth, db, app };